// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__BJm9S","header":"PatientQuestionnaire_header__13fMg","info":"PatientQuestionnaire_info__KXPjn"};